@use '@/scss/underscore' as _;

.filter {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .assignButton {
    margin-left: _.unit(2);
  }
}
